import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ad9cafe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-6 mx-auto my-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Risk statements", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " There are many risks involved in using a transfer to provide, or support an income. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "These are not the case when using your scheme benefits.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This is a list of some of those risks that mean your pots may run out: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "If you live longer than expected"),
  /*#__PURE__*/_createElementVNode("li", null, "If the growth on your pots is lower on average than expected"),
  /*#__PURE__*/_createElementVNode("li", null, "If your investments reduce in value significantly in any year"),
  /*#__PURE__*/_createElementVNode("li", null, "If you pay higher charges than expected"),
  /*#__PURE__*/_createElementVNode("li", null, " If you take income from your pots at a greater rate than planned ")
], -1))
const _hoisted_7 = { class: "form-check mb-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label lead",
  for: "chkIUnderstandTheRisks"
}, " I understand the risks above are some of the risks involved in using a transfer to provide an income for life and these are not risks with my current scheme benefits. ", -1))
const _hoisted_9 = { id: "buttonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_buttons = _resolveComponent("nav-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("input", {
          type: "checkbox",
          ref: "chkIUnderstandTheRisks",
          id: "chkIUnderstandTheRisks",
          class: "form-check-input",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkIfUserHasSignedOff && _ctx.checkIfUserHasSignedOff(...args)))
        }, null, 544),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_nav_buttons, {
        previousVisible: false,
        nextEnabled: _ctx.nextIsEnabled,
        onNextClicked: _ctx.onNextClicked
      }, null, 8, ["nextEnabled", "onNextClicked"])
    ])
  ]))
}